import React from "react";
import img from "../../src/assets/images/404.svg";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="leap-flex  leap-h-screen leap-bg-[#1D2346] leap-items-center leap-justify-center">
      <div className="leap-flex leap-px-2 leap-flex-col-reverse xl:leap-flex-row leap-items-center leap-justify-around leap-w-full">
        {/* Left Section - Text */}
        <div className="leap-text-left leap-text-white">
          <h1 className="leap-text-3xl sm:leap-text-4xl md:leap-text-5xl leap-font-bold">
            Oops....
          </h1>
          <p className="leap-text-2xl sm:leap-text-3xl md:leap-text-4xl leap-my-4">
            Page not found
          </p>
          <p className="leap-text-base sm:leap-text-lg md:leap-text-xl leap-mb-14 xl:leap-mb-10">
            This Page doesn’t exist or was removed! <br />
            We suggest you back to home.
          </p>
          <button
            className="leap-bg-gradient-to-r leap-from-[#3B29AB] leap-to-[#EB3DF7] leap-text-white leap-py-4 leap-px-5 leap-font-bold leap-rounded-xl leap-shadow-md leap-transform leap-transition leap-duration-300 hover:leap-scale-105"
            onClick={() => navigate("/")}
          >
            Back To Home
          </button>
        </div>

        {/* Right Section - 404 Image */}
        <div className="leap-flex  leap-items-center leap-justify-center leap-pb-5  xl:leap-py-0">
          <img
            src={img}
            alt="404 illustration"
            className="leap-max-w-[320px]  leap-px-2 md:leap-max-w-[400px] xl:leap-max-w-lg leap-h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
